import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { useHistory } from 'react-router';
import { CustomRoutes } from '../../../utils/CustomRoutes';
import CreateJob from '../components/CreateJobsComponent';
import SearchJobsComponent from '../components/SearchJobsComponent';
import ViewJobComponent from '../components/ViewJobComponent';

const ViewJobPage: React.FC = () => {
    const history = useHistory();
    const goToViewInterviews = () => {
        history.push(CustomRoutes.viewInterview);
    }
    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>{'View Job'}</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar color="primary">
                        <IonTitle size="large">View Job</IonTitle>
                    </IonToolbar>
                </IonHeader>

                <ViewJobComponent name={''}></ViewJobComponent>
            </IonContent>
        </IonPage>
    );
};

export default ViewJobPage;
